function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Form, Input, Button, Select, message, InputNumber, Modal, Alert } from "antd";
import Common from '../includes/Common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var AddCashEntry = function AddCashEntry(_ref) {
  var handler = _ref.handler,
    transaction = _ref.transaction,
    cashBox = _ref.cashBox;
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var saveCashierTransaction = function saveCashierTransaction(formData) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    axios.post(Common.baseApiUrl + 'addcashin', formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  var onFinish = function onFinish(values) {
    var total = values.one_hundred * 100 + values.five_hundred * 500 + values.one_thousand * 1000 + values.two_thousand * 2000 + values.five_thousand * 5000 + values.ten_thousand * 10000 + values.twenty_thousand * 20000;
    if (total != transaction.total_cash) return message.error({
      content: "Le total du billetage ne correspond pas avec la valeur à encaisser",
      delay: 4
    });
    var formData = new FormData();
    formData.append('one_hundred', values.one_hundred);
    formData.append('five_hundred', values.five_hundred);
    formData.append('one_thousand', values.one_thousand);
    formData.append('two_thousand', values.two_thousand);
    formData.append('five_thousand', values.five_thousand);
    formData.append('ten_thousand', values.ten_thousand);
    formData.append('twenty_thousand', values.twenty_thousand);
    formData.append('comment', "Collecte du chef de piste ".concat(transaction.user.prenom, " ").concat(transaction.user.nom));
    formData.append('operation_type', 1);
    formData.append('user_id', Common.currentUser.id);
    formData.append('expense_category_id', null);
    formData.append('cash_box_id', cashBox.id);
    formData.append('pump_report_id', transaction.id);
    formData.append('amount', total);
    confirm({
      title: "Confirmez-vous l'encaissement ?",
      content: /*#__PURE__*/_jsx("div", {
        children: "".concat(transaction.total_cash.toLocaleString('Fr'), " GNF en cash et ").concat(transaction.total_coupon.toLocaleString('Fr'), " GNF en bons")
      }),
      onOk: function onOk() {
        saveCashierTransaction(formData);
      }
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      one_hundred: 0,
      five_hundred: 0,
      one_thousand: 0,
      two_thousand: 0,
      five_thousand: 0,
      ten_thousand: 0,
      twenty_thousand: 0
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("b", {
      children: ["ENCAISSEMENT DE ", transaction.total_cash.toLocaleString('Fr'), " GNF en cash et ", transaction.total_coupon.toLocaleString('fr'), " GNF en bons de carburant, veuillez faire le billetage et confirmer."]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "one_hundred",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "x 100 GNF",
          style: {
            width: '240px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "five_hundred",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "x 500 GNF",
          style: {
            width: '240px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "one_thousand",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "x 1 000 GNF",
          style: {
            width: '240px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "two_thousand",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "x 2 000 GNF",
          style: {
            width: '240px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "five_thousand",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "x 5 000 GNF",
          style: {
            width: '240px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "ten_thousand",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "x 10 000 GNF",
          style: {
            width: '240px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "twenty_thousand",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "x 20 000 GNF",
          style: {
            width: '240px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsxs(Form.Item, {
        children: [ContextHolder, /*#__PURE__*/_jsx(Button, {
          loading: isFormLoading,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "VALIDER"
          })
        })]
      })]
    })]
  });
};
export default AddCashEntry;